import apiApp from '@/api/config/apiApp'

function createEvent (event) {
  return apiApp.post('/events', event)
}

export {
  createEvent
}
